module.exports = __webpack_public_path__ + "media/images/emblems/Mont-la-Ville-coat_of_arms-30c562ba3deb7c6a068fa70d9efc4b7c.svg";